// Article page comments block script

// append comments to the comments container
const commentsContainer = document.querySelector("[data-article-comments-container]");
const loadMoreButton = document.querySelector("[data-load-more]");
let nextURL = commentsContainer.dataset.nextUrl;
loadMoreButton.addEventListener("click", () => {
  fetch(nextURL).then((response) => {
    if (!response.ok) {
      throw new Error(`HTTP error: ${response.status}`);
    }
    return response.text();
  }).then((html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    nextURL = doc.querySelector("[data-article-comments-container]").dataset.nextUrl;
    if (!nextURL) {
      loadMoreButton.remove();
    }
    const allComments = doc.querySelectorAll("[data-comment]");
    allComments.forEach((comment) => {
      commentsContainer.append(comment);
    })
  }).catch((error) => {
    console.log(error);
  })
})
